import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8598fe9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "popup-box"
};
const _hoisted_2 = {
  class: "line-one"
};
const _hoisted_3 = {
  class: "book-info"
};
const _hoisted_4 = {
  class: "book-title color-111"
};
const _hoisted_5 = {
  class: "book-introduction color-555 mt8"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 1,
  class: "img-text"
};
const _hoisted_8 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h4", _hoisted_2, _toDisplayString($props.popupData.title), 1), $props.popupData.type == 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($props.popupData.books, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "list-item flex"
    }, [_createVNode(_component_van_image, {
      onClick: $event => _ctx.openApp(item),
      src: item.coverWap,
      class: "list-image",
      radius: "6px"
    }, null, 8, ["onClick", "src"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.bookName), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.introduction), 1), _createElementVNode("span", {
      onClick: $event => $setup.goDetailsPage(item),
      class: "push-btn"
    }, "查看", 8, _hoisted_6)])]);
  }), 128)) : _createCommentVNode("", true), $props.popupData.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
    innerHTML: $props.popupData.content
  }, null, 8, _hoisted_8)])) : _createCommentVNode("", true), _createElementVNode("span", {
    class: "popup-close-btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.closePopup && $setup.closePopup(...arguments);
    })
  })]);
}